import { UtcDate } from '@/helpers/date';

export default {
  computesRequired: true,
  params: ['dateOfInsuranceStart', 'taxiUsedFor'],
  validate (value, { dateOfInsuranceStart, taxiUsedFor }) {
    let message = '';
    const valueDate = new UtcDate(value);

    const dateOfInsuranceStartDate = new UtcDate(dateOfInsuranceStart);
    const today = new UtcDate();
    const maxDate = dateOfInsuranceStartDate.isValid() ? dateOfInsuranceStartDate : today.addDays(this.constants.DATE_OF_INSURANCE_START_MAX_DAYS);
    const age = (value && valueDate.isValid()) ? maxDate.differenceInYears(valueDate) : null;
    if (age < this.constants.INSURER_MIN_AGE) {
      message = 'Minimum age is 16 years old.';
      return message;
    };

    if (
      taxiUsedFor === 1 &&
      age < this.constants.TAXI_MIN_AGES_BY_USE[1]
    ) {
      message = `Minimum age for ${this.constants.TAXI_USE[taxiUsedFor]} is 18 years old.`;
      return message;
    }

    if (
      taxiUsedFor === 2 &&
      age < this.constants.TAXI_MIN_AGES_BY_USE[2]
    ) {
      message = `Minimum age for ${this.constants.TAXI_USE[taxiUsedFor]} is 21 years old.`;
      return message;
    }

    return true;
  },
};
